import React, { useEffect, useRef, useState } from "react";
import "./mypurchases.css";
import Brudcrumb from "../../components/brudcrumb/brudcrumb";
import DefaultLayout from "../../layout/defaultLayout";
import { useSelector } from "react-redux";
import axios from "axios";
import "./mypurchases.css";
import { IoArrowBackOutline } from "react-icons/io5";
import { useNavigate } from "react-router-dom";
import { Input, Loader } from "rsuite";
import { ToastContainer, toast } from "react-toastify";
import PaginationSt1 from "../../components/paginationSt1";
import moment from "moment/moment";
import { useCallback } from "react";
import InfiniteScroll from "react-infinite-scroll-component";
import { BASE_URL } from "../../CONSTS";
const MyPurchases = () => {
  const navigate = useNavigate();
  const language = useSelector((state) => state.language.lang);
  const accessToken = localStorage.getItem("accessToken");
  const [deliver_note, set_deliver_note] = useState("");
  const [order_note, set_order_note] = useState("");
  const dataAccess = accessToken ? JSON.parse(accessToken) : null;
  // console.log(data)
  const [orderQ, setOrderQ] = useState(false);
  const options = {
    headers: {
      "Accept-Language": language,
    },
  };
  const getOrderQ = async () => {
    const qu = await axios.get(
      `${BASE_URL}api/web/v1/product/rate-question?access-token=${dataAccess?.access_token}`,
      options
    );

    setOrderQ(qu.data.data[0]);
  };

  useEffect(() => {
    getOrderQ();
  }, [language]);
  const [pageCount, setPagesCount] = useState(false);
  const [page, setPage] = useState(1);
  const [prePage, setPerPage] = useState(false);
  const [showDelivery, setShowDelivery] = useState(false);
  if (showDelivery) {
    document.body.style.overflow = "hidden";
  } else {
    document.body.style.overflow = "auto";
  }
  const [showevalderiver, setshowevalderiver] = useState(false);
  const data = accessToken ? JSON.parse(accessToken) : null;
  const [Purchases, setPurchases] = useState([]);
  const [loading, setloading] = useState(true);
  const [delobjloading, setdelobjloading] = useState({
    id: "",
    loading: false,
  });
  const [showeval, setshoweval] = useState(false);
  const [showorderdelete, setshoworderdelete] = useState(false);

  const [starrate, setstarrate] = useState(0);
  const [deleteNotes, setDeleteNotes] = useState("");
  // deleteNotes
  const [item, setitem] = useState({});
  const [hasNextPage, sethasNextPage] = useState(true);

  const getpurchases = () => {
    if (!Purchases && !Purchases.length) {
      setDataLoading(true);
    } else {
      setDataPLoading(true);
    }
    const options = {
      headers: {
        "Accept-Language": language, // Set the desired language code here
      },
    };
    axios
      .get(
        `${BASE_URL}api/web/v1/product/order?access-token=${data?.access_token}&page=${page}`,
        options
      )
      .then((res) => {
        // console.log(res.data.data[0].items);
        // console.log(page)
        let filterdata = [...res?.data?.data[0]?.items];
        // console.log(filterdata)
        // let newfilter=filterdata.filter(item=>item.)
        filterdata.map((item, index) => {
          return { ...item, delloading: false };
        });
        setPurchases(
          Purchases && Purchases.length
            ? [...Purchases, ...filterdata]
            : [...filterdata]
        );
        setPagesCount(res.data.data[0]?._meta?.NumberOfPage);
        sethasNextPage(page < res.data.data[0]?._meta?.NumberOfPage);
        // console.log(res.data.data[0]?._meta)
        setPerPage(res.data.data[0]?._meta?.perPage);
        // setPurchases(res?.data?.data[0]?.items);
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setloading(false);
        setDataLoading(false);
        setDataPLoading(false);
      });
  };

  const handledeleteorder = () => {
    // console.log(id)
    setdelobjloading({
      id: item.id,
      loading: true,
    });
    // console.log(item);
    let filterdata = [...Purchases];
    filterdata.map((ite, index) => {
      if (ite.id == item.id) {
        return { ...ite, delloading: true };
      } else return { ...ite };
    });
    setPurchases(filterdata);
    const formdata = new FormData();
    formdata.append("id", item.id);
    formdata.append("deleteNotes", deleteNotes);

    axios
      .post(
        `${BASE_URL}api/web/v1/product/order-delete?access-token=${data?.access_token}`,
        formdata,
        options
      )
      .then(async (res) => {
        // console.log(res.data.data[0])
        if (res?.data?.data[0]?.status == 0) {
          // getpurchases()
          toast.error(res?.data?.data[0]?.message);
        } else if (res?.data?.data[0]?.status == 1) {
          toast.success(res?.data?.data[0]?.message);
          await getpurchases();
          window.location.reload();
        } else {
          toast.error(language == "ar" ? "حدث خطأ ما" : "something wen error");
        }
      })
      .finally(() => {
        setshoworderdelete(false);
        setdelobjloading({
          id: item.id,
          loading: false,
        });
        let filterdata = [...Purchases];
        filterdata.map((item, index) => {
          return { ...item, delloading: false };
        });
        setPurchases(filterdata);
      });
  };

  useEffect(() => {
    getpurchases();
  }, [page, language]);

  const [dataLoading, setDataLoading] = useState(false);
  const [dataPLoading, setDataPLoading] = useState(false);
  useEffect(() => {}, [page, language]);
  const [rateArr, setRateArr] = useState([]);
  const [send_loading, setSendLoading] = useState(false);

  const handleaddrate = async () => {
    const formData = new FormData();
    formData.append("order_id", item.id);
    formData.append("rate", rateArr.map((item) => item.value).join(","));
    formData.append("question_id", rateArr.map((item) => item.type).join(","));
    formData.append("type", rateArr.map((item) => item.ev_type).join(","));
    formData.append("driver_id", item?.driver?.id);
    formData.append("order_note", order_note);
    formData.append("deliver_note", deliver_note);
    // console.log(item);
    // for (const value of formData.values()) {
    //   console.log(value);
    // }

    setSendLoading(true);
    await axios
      .post(
        `${BASE_URL}api/web/v1/product/order-rate?access-token=${data.access_token}`,
        formData,
        options
      )
      .then((res) => {
        // console.log(res.data)
        // console.log(res.data.data[0]);
        if (res.data.data[0].status == 0) {
          toast.warn(res.data.data[0].message);
        } else {
          getOrderQ();
          setshoweval(false);
          setshowevalderiver(false);
          toast.success(res.data.data[0].message);
          getpurchases();
        }
        setSendLoading(false);
      });
    getpurchases();
    window.location.reload();
  };
  const purchases_ref = useRef();

  useEffect(() => {
    // console.log("rateArr", rateArr);
  }, [rateArr]);
  return (
    <DefaultLayout
      children={
        <>
          <Brudcrumb title={language === "ar" ? "مشترياتى" : "My Purchases"} />
          {dataLoading ? (
            <Loader />
          ) : (
            <div className="purchases" id="purchases" ref={purchases_ref}>
              <InfiniteScroll
                dataLength={Purchases.length} //This is important field to render the next data
                next={() => {
                  if (hasNextPage) setPage((prev) => prev + 1);
                }}
                hasMore={hasNextPage}
                // below props only if you need pull down functionality
                refreshFunction={() => {
                  if (hasNextPage) setPage((prev) => prev + 1);
                }}
                pullDownToRefresh
                pullDownToRefreshThreshold={50}
              >
                {Purchases?.map((item, index) => {
                  return (
                    <div className="purchase">
                      <div className="resource_place">
                        <h4>#{item.id}</h4>
                        <div style={{ justifyContent: "start" }}>
                          <h5 style={{ maxWidth: "90%", textAlign: "start" }}>
                            <h4>
                              {item.delivery_status == 0 ||
                              item.delivery_status == 2
                                ? language == "ar"
                                  ? "الاستلام من الفرع"
                                  : "Get From Branch"
                                : item?.address}
                            </h4>
                          </h5>
                          <img src={require("../../assets/home.png")} alt="" />
                        </div>
                      </div>
                      <div>
                        <div className="order_time">
                          <h5
                            style={{
                              direction: language == "ar" ? "ltr" : "ltr",
                            }}
                          >
                            {moment(item.date).format("YYYY-MM-DD h:mm:ss")}
                          </h5>
                        </div>
                        <div>
                          <h4>{item.total_price} SAR</h4>
                          <h5>
                            {language == "ar" ? "قيمة الطلب" : "Order Value"}
                          </h5>
                        </div>
                      </div>
                      <div className="order_status">
                        <div>
                          {item.status_name == "NEW" ||
                          item.status_name == "جديد" ? (
                            language == "ar" ? (
                              <h4 style={{ color: "var(--main-color)" }}>
                                جديد
                              </h4>
                            ) : (
                              <h4 style={{ color: "var(--main-color)" }}>
                                New
                              </h4>
                            )
                          ) : item.status_name == "IN CHETCHEN" ||
                            item.status_name == "فى المطبخ" ? (
                            language == "ar" ? (
                              <h4 style={{ color: "var(--main-color)" }}>
                                فى المطبخ
                              </h4>
                            ) : (
                              <h4 style={{ color: "var(--main-color)" }}>
                                In The Kitchen
                              </h4>
                            )
                          ) : item.status_name == "Rejected" ||
                            item.status_name == "مرفوض" ? (
                            language == "ar" ? (
                              <h4 style={{ color: "var(--main-color)" }}>
                                مرفوض
                              </h4>
                            ) : (
                              <h4 style={{ color: "var(--main-color)" }}>
                                Rejected
                              </h4>
                            )
                          ) : item.status_name == "Returned" ||
                            item.status_name == "مرتجع" ? (
                            language == "ar" ? (
                              <h4 style={{ color: "var(--main-color)" }}>
                                مرتجع
                              </h4>
                            ) : (
                              <h4 style={{ color: "var(--main-color)" }}>
                                Returned
                              </h4>
                            )
                          ) : item.status_name == "IN THE ROAD" ||
                            item.status_name == "فى الطريق" ? (
                            language == "ar" ? (
                              <h4 style={{ color: "var(--main-color)" }}>
                                فى الطريق
                              </h4>
                            ) : (
                              <h4 style={{ color: "var(--main-color)" }}>
                                In The Road
                              </h4>
                            )
                          ) : item.status_name == "Order RECIEVED" ||
                            item.status_name == "تم توصيل الطلب" ? (
                            language == "ar" ? (
                              <h4 style={{ color: "var(--main-color)" }}>
                                تم التوصيل
                              </h4>
                            ) : (
                              <h4 style={{ color: "var(--main-color)" }}>
                                Has Received
                              </h4>
                            )
                          ) : null}
                          {item.status_name == "NEW" ||
                          item.status_name == "جديد" ? (
                            <img
                              src={require("../../assets/new2.png")}
                              alt=""
                            />
                          ) : item.status_name == "IN CHETCHEN" ||
                            item.status_name == "فى المطبخ" ? (
                            <img
                              src={require("../../assets/kitchen2.png")}
                              alt=""
                            />
                          ) : item.status_name == "Rejected" ||
                            item.status_name == "مرفوض" ? (
                            <img
                              style={{ width: "30px" }}
                              src={require("../../assets/rejected.png")}
                              alt=""
                            />
                          ) : item.status_name == "Returned" ||
                            item.status_name == "مرتجع" ? (
                            <div
                              style={{
                                width: "50px",
                                height: "50px",
                                borderRadius: "50%",
                                backgroundColor: "#D31E4B",
                                maxWidth: "100%",
                                maxHeight: "100%",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                margin: "0px",
                              }}
                            >
                              <img
                                src={require("../../assets/takeoff.png")}
                                alt=""
                              />
                            </div>
                          ) : item.status_name == "Order RECIEVED" ||
                            item.status_name == "تم توصيل الطلب" ? (
                            <img
                              src={require("../../assets/delivaryed.png")}
                              alt=""
                            />
                          ) : item.status_name == "IN THE ROAD" ? (
                            <img src={require("../../assets/car.png")} alt="" />
                          ) : null}

                          {/* <h4>{item.}</h4> */}
                        </div>
                        <h4>
                          {language === "ar" ? "وضع الطلب" : "Order Status"}
                        </h4>
                      </div>
                      <div
                        style={{
                          justifyContent:
                            item.status_name == "NEW" ||
                            item.status_name == "جديد" ||
                            item.status_name == "IN THE ROAD" ||
                            item.status_name == "Order RECIEVED" ||
                            item.status_name == "تم توصيل الطلب" ||
                            item.status_name == "IN THE ROAD" ||
                            item.status_name == "فى الطريق"
                              ? "space-between"
                              : "start",
                        }}
                      >
                        {item.status_name == "NEW" ||
                        item.status_name == "جديد" ? (
                          delobjloading.id == item.id &&
                          delobjloading.loading ? (
                            <button
                              className="dellaod"
                              style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                              }}
                            >
                              <Loader />
                            </button>
                          ) : (
                            <button
                              onClick={() => {
                                setshoworderdelete(true);
                                setitem(item);
                                // handledeleteorder(item.id)
                              }}
                            >
                              <img
                                src={require("../../assets/cancle.png")}
                                alt=""
                              />
                              <span
                                style={{
                                  color: "#D31E4B",
                                  borderColor: "#d31e4b",
                                }}
                              >
                                {language === "ar"
                                  ? "إلغاء الطلب"
                                  : "Cancelling order"}
                              </span>
                            </button>
                          )
                        ) : item.status_name == "IN THE ROAD" ||
                          item.status_name == "فى الطريق" ? (
                          <button
                            onClick={() => {
                              setShowDelivery(item);
                            }}
                          >
                            <span>
                              {language === "ar"
                                ? "تواصل مع السائق"
                                : "Contact With The Delivary Man"}
                            </span>
                            <img
                              src={require("../../assets/delivaryman.png")}
                              alt=""
                            />
                          </button>
                        ) : item.status_name == "Order RECIEVED" ||
                          (item.status_name == "تم توصيل الطلب" &&
                            !item.is_rate) ? (
                          <button
                            onClick={() => {
                              setitem(item);
                              // console.log(item);
                              setshoweval(true);
                            }}
                          >
                            <span>
                              {language === "ar"
                                ? "تقيم الطلب"
                                : "Evaluate the request"}
                            </span>
                            <img
                              src={require("../../assets/evaluate.png")}
                              alt=""
                            />
                          </button>
                        ) : null}
                        <button
                          onClick={() => {
                            navigate("/orderdetails", {
                              state: { product: item },
                            });
                          }}
                          style={{ alignSelf: "start" }}
                        >
                          <img
                            src={require("../../assets/details.png")}
                            alt=""
                          />
                          <span>
                            {language === "ar"
                              ? "تفاصيل الطلب"
                              : "Order Detals"}
                          </span>
                        </button>
                      </div>
                    </div>
                  );
                })}
                {dataPLoading ? <Loader /> : null}
              </InfiniteScroll>
            </div>
          )}
          {showeval ? (
            <div className="showeval">
              <div className="evaluation_div evaluate_person_div">
                <div>
                  <img src={require("../../assets/evalimg.png")} alt="" />
                  <h4>
                    {language == "ar" ? "تقييم الطلب" : "Evaluate the Order"}
                  </h4>
                </div>
                <h4>
                  {language == "ar"
                    ? "برجاء تقييم الطلب الخاص بك"
                    : "please evaluate your order"}
                </h4>
                <div className="stars evaluate_person">
                  {orderQ?.order && orderQ?.order.length
                    ? orderQ?.order?.map((d_item, d_index) => {
                        return (
                          <div>
                            {" "}
                            <p>
                              {language == "ar"
                                ? d_item?.title
                                : d_item?.title_en}
                            </p>
                            <div className="evaluated">
                              {Object.keys(orderQ?.answer)
                                .map((key) => ({
                                  key: parseInt(key, 10),
                                  value: orderQ?.answer[key],
                                }))
                                .map((item, index) => {
                                  // console.log(item);
                                  return (
                                    <div
                                      className="terms_and_con"
                                      style={{
                                        display: "flex",
                                        gap: "10px",
                                        alignItems: "center",
                                      }}
                                    >
                                      <input
                                        className="rs-input"
                                        type="radio"
                                        name={"radio" + d_index}
                                        style={{ width: "50px" }}
                                        required
                                        value={item.key}
                                        onChange={(e) => {
                                          return e.currentTarget.checked &&
                                            rateArr.findIndex(
                                              (item) =>
                                                d_item?.id == item.type &&
                                                item.ev_type == 2
                                            ) < 0
                                            ? setRateArr([
                                                ...rateArr,
                                                {
                                                  type: d_item?.id,
                                                  ev_type: 2,
                                                  value: e.target.value,
                                                },
                                              ])
                                            : (rateArr[
                                                rateArr.findIndex(
                                                  (item) =>
                                                    d_item?.id == item.type &&
                                                    item.ev_type == 2
                                                )
                                              ].value = e.currentTarget.value);
                                        }}
                                      />
                                      <label
                                        htmlFor={"radio" + d_index}
                                        style={{ color: "var(--main-color)" }}
                                      >
                                        {language === "ar"
                                          ? item?.value
                                          : item?.value}
                                      </label>
                                    </div>
                                  );
                                })}
                            </div>
                          </div>
                        );
                      })
                    : null}
                </div>
                <textarea
                  onChange={(e) => set_deliver_note(e?.target?.value)}
                  value={deliver_note}
                  placeholder={language == "ar" ? "ملاحظات" : "Notes"}
                ></textarea>

                <div className="actions">
                  <button
                    onClick={() => {
                      setshoweval(false);
                      setRateArr([]);
                    }}
                  >
                    {language == "ar" ? "إلغاء" : "Cancle"}
                  </button>
                  <button
                    onClick={() => {
                      setitem(item);
                      // console.log(item)
                      setshowevalderiver(true);
                    }}
                  >
                    <span>
                      {language === "ar"
                        ? "تقيم السائق"
                        : "Evaluate the driver"}
                    </span>
                    <img src={require("../../assets/evaluate.png")} alt="" />
                  </button>
                </div>
              </div>
            </div>
          ) : null}
          {showevalderiver ? (
            <div className="showeval">
              <div className="evaluation_div evaluate_person_div">
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    width: "100%",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "10px",
                    }}
                  >
                    <img src={require("../../assets/evalimg.png")} alt="" />
                    <h4>
                      {language == "ar"
                        ? "تقييم السائق"
                        : "Evaluate the Driver"}
                    </h4>
                  </div>
                  <IoArrowBackOutline
                    onClick={() => {
                      setshowevalderiver(false);
                    }}
                    style={{ fontSize: "22px", cursor: "pointer" }}
                  />
                </div>
                <h4>
                  {language == "ar"
                    ? "برجاء تقييم السائق"
                    : "please evaluate the driver"}
                </h4>
                <div className="stars evaluate_person">
                  {orderQ?.driver && orderQ?.driver.length
                    ? orderQ?.driver?.map((d_item, d_index) => {
                        return (
                          <div>
                            {" "}
                            <p>
                              {language == "ar"
                                ? d_item?.title
                                : d_item?.title_en}
                            </p>
                            <div className="evaluated">
                              {Object.keys(orderQ?.answer)
                                .map((key) => ({
                                  key: parseInt(key, 10),
                                  value: orderQ?.answer[key],
                                }))
                                .map((item, index) => {
                                  // console.log(item);
                                  return (
                                    <div
                                      className="terms_and_con"
                                      style={{
                                        display: "flex",
                                        gap: "10px",
                                        alignItems: "center",
                                      }}
                                    >
                                      <input
                                        className="rs-input"
                                        type="radio"
                                        name={"radio" + d_index}
                                        style={{ width: "50px" }}
                                        required
                                        value={item.key}
                                        onChange={(e) => {
                                          // console.log(rateArr);
                                          return e.currentTarget.checked &&
                                            rateArr.findIndex(
                                              (item) =>
                                                d_item?.id == item.type &&
                                                item.ev_type == 1
                                            ) < 0
                                            ? setRateArr([
                                                ...rateArr,
                                                {
                                                  type: d_item?.id,
                                                  ev_type: 1,
                                                  value: e.target.value,
                                                },
                                              ])
                                            : (rateArr[
                                                rateArr.findIndex(
                                                  (item) =>
                                                    d_item?.id == item.type &&
                                                    item.ev_type == 1
                                                )
                                              ].value = e.currentTarget.value);
                                        }}
                                      />
                                      <label
                                        htmlFor={"radio" + d_index}
                                        style={{ color: "var(--main-color)" }}
                                      >
                                        {language === "ar"
                                          ? item?.value
                                          : item?.value}
                                      </label>
                                    </div>
                                  );
                                })}
                            </div>
                          </div>
                        );
                      })
                    : null}
                </div>
                <textarea
                  onChange={(e) => set_order_note(e?.target?.value)}
                  value={order_note}
                  placeholder={language == "ar" ? "ملاحظات" : "Notes"}
                ></textarea>
                <div className="actions">
                  <button
                    onClick={() => {
                      setRateArr([
                        ...rateArr.filter((item) => item.ev_type != 1),
                      ]);
                      setshowevalderiver(false);
                    }}
                  >
                    {language == "ar" ? "إلغاء" : "Cancle"}
                  </button>
                  <button
                    onClick={() => {
                      return !send_loading ? handleaddrate() : null;
                    }}
                  >
                    {!send_loading ? (
                      <>{language == "ar" ? "إرسال" : "Send"}</>
                    ) : (
                      <Loader />
                    )}
                  </button>
                </div>
              </div>
            </div>
          ) : null}
          {showorderdelete ? (
            <div className="showeval">
              <div className="evaluation_div cancle_div">
                <div>
                  <img src={require("../../assets/evalimg.png")} alt="" />
                  <h4>
                    {language == "ar" ? "إلغاء الطلب" : "Cancel the Order"}
                  </h4>
                </div>
                <h4>
                  {language == "ar"
                    ? "برجاء كتابة سبب الإلغاء"
                    : "please Enter Reason Of Cancel"}
                </h4>
                <textarea
                  placeholder={language == "ar" ? "ملاحظات" : "Notes"}
                  onChange={(e) => setDeleteNotes(e.target.value)}
                ></textarea>
                <div className="actions">
                  <button
                    onClick={() => {
                      setshoworderdelete(false);
                    }}
                  >
                    {language == "ar" ? "إلغاء" : "Cancle"}
                  </button>
                  <button
                    onClick={() => {
                      handledeleteorder();
                    }}
                  >
                    {language == "ar" ? "إرسال" : "Send"}
                  </button>
                </div>
              </div>
            </div>
          ) : null}
          {/* <PaginationSt1
            pagesCount={pageCount}
            setPageNumber={setPage}
            pageNumber={page}
            increasementRate={prePage}
            setElemsNumber={prePage}
          /> */}
          <ToastContainer />
          {showDelivery ? (
            <div
              className="del_acc"
              style={{ justifyContent: "center", alignItems: "center" }}
            >
              <div
                className="overlay"
                onClick={() => setShowDelivery(false)}
              ></div>
              <div
                className="contact_with_delivery"
                style={{
                  width: "min(400px, 100%)",
                  padding: "15px 20px",
                  margin: "auto",
                  borderRadius: "5px",
                  // borderBottomLeftRadius: "10",
                  // borderBottomRightRadius: "10",
                  background: "white",
                  position: "fixed",
                  // bottom: "10px",
                  top: "50%",
                  left: "50%",
                  translate: "-50%",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  gap: "13px",
                }}
              >
                <svg
                  style={{ margin: "auto" }}
                  xmlns="http://www.w3.org/2000/svg"
                  width="110.148"
                  height="5"
                  viewBox="0 0 110.148 5"
                  onClick={() => setShowDelivery(false)}
                >
                  <line
                    id="Line_26"
                    data-name="Line 26"
                    x2="105.148"
                    transform="translate(2.5 2.5)"
                    fill="none"
                    stroke="#b4b4b4"
                    stroke-linecap="round"
                    stroke-width="5"
                  />
                </svg>

                <div
                  className="delivery_icon"
                  style={{
                    display: "flex",
                    width: "100%",
                    justifyContent: "space-between",
                    background: "#F7F7F7",
                    border: ".5px solid#707070",
                    borderRadius: "9px",
                    padding: "13px",
                    alignItems: "center",
                  }}
                >
                  <div className="deliv_img">
                    <span>
                      <svg
                        id="delivery-man_1_"
                        data-name="delivery-man (1)"
                        xmlns="http://www.w3.org/2000/svg"
                        width="72.457"
                        height="72.558"
                        viewBox="0 0 72.457 72.558"
                      >
                        <path
                          id="Path_4264"
                          data-name="Path 4264"
                          d="M73.368,27.168H40.063a1.124,1.124,0,0,0-1.189,1.189v7.969L35.9,35.614,32.688,32.4c3.568-3.331,3.806-10.348,3.806-12.371,4.4,0,7.494-1.189,8.683-3.331a4.3,4.3,0,0,0-.476-4.52,5.97,5.97,0,0,0-5.234-2.855H35.186a9.44,9.44,0,0,0-7.375-7.969A23.171,23.171,0,0,0,24.6,1C12.229,1,10.326,6.947,10.326,10.516v5.947a3.627,3.627,0,0,0,1.071,2.5,5.406,5.406,0,0,0-1.071,3.449,4.483,4.483,0,0,0,3.806,4.639,13.625,13.625,0,0,0,2.26,4.163l-4.4,4.4c-.952,1.071.238,2.141.238,2.141L7.115,42.869C6.639,43.464,2,48.222,2,52.147c0,.238,0,.357.119.476L8.066,64.518c.119.357.476.476.714.595a11.756,11.756,0,0,0,2.736.357c0,.119-.119,6.78-.119,6.78a1.124,1.124,0,0,0,1.189,1.189,1.124,1.124,0,0,0,1.189-1.189V68.919c1.784,2.141,4.639,4.52,8.326,4.52s10.467-2.379,16.415-4.52c1.071-.357,2.022-.714,2.974-1.071a7.58,7.58,0,0,1,.833-.238v4.758a1.189,1.189,0,1,0,2.379,0V67.016a21.454,21.454,0,0,1,5.947-.595h8.326c2.022,0,4.758-.714,5.591-2.855a4.931,4.931,0,0,0,.357-1.9h8.326a1.124,1.124,0,0,0,1.189-1.189V28.358a.984.984,0,0,0-1.071-1.189ZM60.284,29.547v6.423l-3.093-1.546c-.119-.119-.238-.119-.476-.119s-.357,0-.476.119l-3.093,1.546V29.547ZM25.552,36.089a2.616,2.616,0,0,0-.714-.595,12.766,12.766,0,0,0,3.806-.595l-.476,1.427L26.979,39.42S25.671,36.089,25.552,36.089Zm5.828-1.665,2.5,2.5-1.189,2.26-2.022-2.736Zm2.141-22.719a15.38,15.38,0,0,0-2.736,2.855c-2.022,2.974-3.806,3.093-3.806,3.093h-6.3a8.982,8.982,0,0,0,1.308-1.665c1.427-2.141,4.044-4.282,6.185-4.282Zm9.159,1.9c.595.833.714,1.546.357,2.022-.476.952-2.5,2.022-6.542,2.022h-.119a28.444,28.444,0,0,0-.833-4.52,7.559,7.559,0,0,1,3.925-1.427A3.644,3.644,0,0,1,42.68,13.608ZM12.705,10.516c0-4.282,3.449-6.066,7.375-6.78a10.026,10.026,0,0,0-2.617,6.78,1.124,1.124,0,0,0,1.189,1.189,1.192,1.192,0,0,0,1.189-1.189c0-.714.238-6.423,6.066-7.018,5.115.476,6.542,4.044,6.9,5.828H28.168c-3.212,0-6.423,2.617-8.088,5.234-2.022,2.974-3.806,3.093-3.806,3.093H13.895a1.061,1.061,0,0,1-1.189-1.189Zm2.379,14.274a2.26,2.26,0,0,1-2.379-2.379c0-2.141.952-2.379,1.189-2.379H26.979c.357,0,3.093-.119,5.709-4.044a6.537,6.537,0,0,1,.833-1.071,23.363,23.363,0,0,1,.595,5.234c0,.119.476,6.661-2.974,10.467a8.6,8.6,0,0,1-6.542,2.5c-.119,0-6.3-.119-8.326-7.494A1.432,1.432,0,0,0,15.084,24.789Zm2.5,8.683,5.234,3.449L19.6,40.966l-5.234-4.282ZM4.379,51.909c.238-2.5,3.212-6.066,4.4-7.256l5.234-5.234,5,4.163a.874.874,0,0,0,.714.238h.119a1.2,1.2,0,0,0,.833-.476l3.449-4.4,1.665,4.044a1.143,1.143,0,0,0,1.071.714,1.04,1.04,0,0,0,1.071-.714l1.546-3.925,2.26,3.093a1.159,1.159,0,0,0,1.071.476,1.213,1.213,0,0,0,.952-.595l1.9-3.925,2.974.714V57.738c-1.784.595-3.925,1.308-6.185,2.022-1.784.595-3.568,1.189-5.234,1.784a4.6,4.6,0,0,1-5.472-2.022l-4.639-7.969a1.2,1.2,0,1,0-2.022,1.308l3.331,5.472a7.03,7.03,0,0,1-8.564,4.758ZM62.425,62.615c-.357.952-2.022,1.427-3.331,1.427H50.887A27.127,27.127,0,0,0,40.9,65.707c-.952.357-2.022.714-2.974,1.071-5.591,1.9-12.371,4.4-15.7,4.4-4.163,0-7.137-4.282-8.088-5.828a8.885,8.885,0,0,0,5.947-4.4,7.085,7.085,0,0,0,5.947,3.212,6.735,6.735,0,0,0,2.141-.357c1.546-.476,3.331-1.071,5.234-1.784,5.234-1.784,11.657-3.925,13.322-3.925h8.326a1.237,1.237,0,0,1,1.189,1.189H53.147a1.189,1.189,0,1,0,0,2.379s9.04.119,9.516.119a2.205,2.205,0,0,1-.238.833Zm9.754-3.331H58.619a3.538,3.538,0,0,0-3.568-3.568H46.724a27,27,0,0,0-5.472,1.189V29.547h9.516v8.326a1.419,1.419,0,0,0,.595,1.071,1.08,1.08,0,0,0,1.189,0L56.835,36.8l4.282,2.141c0,.119.119.119.357.119a.891.891,0,0,0,.595-.119,1.249,1.249,0,0,0,.595-1.071V29.547h9.516Z"
                          transform="translate(-2 -1)"
                          fill="#fff"
                        />
                        <path
                          id="Path_4265"
                          data-name="Path 4265"
                          d="M43.947,43H39.189a1.189,1.189,0,1,0,0,2.379h4.758a1.189,1.189,0,0,0,0-2.379Z"
                          transform="translate(4.821 6.958)"
                          fill="#fff"
                        />
                        <path
                          id="Path_4266"
                          data-name="Path 4266"
                          d="M39.189,42.379h2.379a1.189,1.189,0,1,0,0-2.379H39.189a1.189,1.189,0,1,0,0,2.379Z"
                          transform="translate(4.821 6.389)"
                          fill="#fff"
                        />
                      </svg>
                    </span>
                  </div>
                  <div
                    className="showDelivery"
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "flex-end",
                      width: "40%",
                      fontSize: "20px",
                    }}
                  >
                    <span>{showDelivery?.driver?.name}</span>
                    <span>{showDelivery?.driver?.mobile}</span>
                  </div>
                  <a
                    className="deliverPhone deliv_img"
                    href={`tel:${showDelivery?.driver?.mobile}`}
                  >
                    <span>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="28.548"
                        height="28.548"
                        viewBox="0 0 28.548 28.548"
                      >
                        <path
                          id="phone-call_2_"
                          data-name="phone-call (2)"
                          d="M16.891,19.342a14.432,14.432,0,0,1-7.676-7.694L13.259,7.6,5.813.145,2.041,3.916A7.018,7.018,0,0,0,0,8.921c0,8.621,11.005,19.626,19.626,19.626a7,7,0,0,0,5-2.041L28.4,22.734,20.95,15.282Zm6.057,5.482a4.639,4.639,0,0,1-3.321,1.344c-7.414,0-17.247-9.833-17.247-17.247A4.647,4.647,0,0,1,3.723,5.6l2.09-2.09L9.9,7.6,6.41,11.088l.291.73A17.1,17.1,0,0,0,16.749,21.853l.721.275,3.48-3.482,4.088,4.088ZM16.653,2.379V0A11.908,11.908,0,0,1,28.547,11.895H26.168a9.526,9.526,0,0,0-9.516-9.516Zm0,4.758V4.758a7.144,7.144,0,0,1,7.137,7.137H21.411A4.758,4.758,0,0,0,16.653,7.137Z"
                          transform="translate(0)"
                          fill="#f05822"
                        />
                      </svg>
                    </span>
                  </a>
                </div>
              </div>
            </div>
          ) : null}
        </>
      }
    />
  );
};

export default MyPurchases;
